var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _path5, _linearGradient3, _path6, _linearGradient4, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 0.767,
    x2: 36,
    y2: 99.25,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#6e0e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#7e1416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#94191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#a71d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#b61f24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#c02026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#c72027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c82127"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9v71.6H0V.8h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9v71.6H0V.8h45z",
    fillOpacity: 0,
    stroke: "#951b1f",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 91.3v-20h6.5c2.5 0 4.1.1 4.8.3 1.1.3 2.1.9 2.9 2 .8 1 1.2 2.3 1.2 3.9 0 1.2-.2 2.3-.7 3.1-.4.8-1 1.5-1.7 2s-1.4.8-2.1.9c-1 .2-2.4.3-4.2.3H14v7.5H9.9zM14 74.7v5.7h2.2c1.6 0 2.7-.1 3.2-.3.5-.2 1-.5 1.3-1 .3-.4.5-1 .5-1.6 0-.7-.2-1.3-.6-1.8-.4-.5-1-.8-1.6-.9-.5-.1-1.5-.1-2.9-.1H14zm14.6-3.4H36c1.7 0 2.9.1 3.8.4 1.2.3 2.2 1 3 1.8.8.9 1.5 2 1.9 3.2.4 1.3.7 2.8.7 4.7 0 1.6-.2 3.1-.6 4.2-.5 1.5-1.2 2.6-2.1 3.5-.7.7-1.7 1.2-2.8 1.6-.9.3-2.1.4-3.6.4h-7.6V71.3zm4 3.4v13.2h3c1.1 0 1.9-.1 2.4-.2.7-.2 1.2-.4 1.6-.8.4-.4.8-1 1.1-1.9.3-.9.4-2.1.4-3.7 0-1.5-.1-2.7-.4-3.5s-.7-1.5-1.1-1.9c-.5-.5-1.1-.8-1.9-.9-.6-.1-1.7-.2-3.3-.2h-1.8zm16.2 16.6v-20h13.7v3.4h-9.7v4.7h8.4v3.4h-8.4v8.5h-4z",
    fill: "#fff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 45.035,
    y1: 72.356,
    x2: 58.535,
    y2: 85.856,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fddfd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#fcdcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#f9d3c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#f4c5b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#efb1a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#e99983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#e27e66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#da5c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#d22b2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d12027"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9H45V.8z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 .8l27 26.9H45V.8z",
    fillOpacity: 0,
    stroke: "#8e191c",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 10.268,
    y1: 31.916,
    x2: 52.274,
    y2: 73.921,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#a50d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#a20d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#9a0c10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#8c090b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#7b0405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#700101"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 54.3c-2.9 3-6.7 5.2-7.8 9.9 7-1.7 11-9.2 14.9-15.9 1.6-2.8 3.8-6.4 5.7-10.2 1.6-3.3 4.2-8.4 4.3-11.3.2-5.5-4.5-12.6-.4-18 2.6-.4 4 .5 3.6 3.2-.8-.8-.5-2.5-2.1-2.5-2.8 2.6-1.2 10.4 0 13.4.7-2.3 1.4-4.8 1.4-7.8 1.2 4.3-.7 7.9-.4 11.3 1 8.7 8.9 13.8 14.9 17.7 5.8-.2 15.3-1.7 17.8 2.5-.6.9-1.8-.7-3.2-1.1-3.1-.7-7.7-.1-11.4-.4 3.5 2.3 7.9 3.7 13.9 3.6-5.5 3.9-13.3-2.6-18.1-3.2-7-.9-14.8 3.4-21.7 3.9 5.6-2.5 12.4-3.7 19.2-5-5.2-3.8-9.7-8.3-12.1-14.8-1.7 5.7-5.5 12.1-9.2 18.4-3.7 6.1-7 12.6-11.7 15.9-2.1 1.5-4.4 1.8-6.8.4.6-5.4 6.7-8.8 9.2-10z",
    fill: "url(#c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 9.782,
    y1: 30.875,
    x2: 53.239,
    y2: 74.332,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#a50d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#a20d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#9a0c10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#8c090b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#7b0405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#700101"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 65.5l-.3.1v-.2l-.6-.3-.6-.3.1-.6c.8-6.1 7.3-9.5 9.8-10.7l1.1 1.6c-2.6 2.7-5.5 4.5-6.9 7.7 5.4-2.3 8.9-8.8 12.5-14.8 1.6-2.8 3.8-6.4 5.7-10.1 1.6-3.2 4.1-8.4 4.2-10.9v-.3c0-3.4-2.1-7.9-2.1-12.2 0-2.1.5-4.2 1.9-6l.2-.5.4-.1c.4-.1.8-.1 1.2-.1 1 0 1.9.2 2.6.8.7.6 1 1.6 1 2.6 0 .3 0 .7-.1 1.1l-.3 1.9-1.4-1.3c-.7-.7-.8-1.4-1-1.8-.1-.1-.1-.2-.1-.2-.6.8-.9 2.3-.9 4 0 1.5.2 3.1.5 4.6.3-1.3.4-2.6.5-4.1l2-.3c.3 1.1.5 2.3.5 3.3 0 2.8-.8 5.3-.8 7.4v.9c.8 8 8.2 13 14.2 16.8 2.4-.1 5.6-.4 8.6-.4 4 0 7.9.5 9.8 3.4l.3.6-.4.5c-.1.2-.4.4-.6.5l2.3-.1-2.6 1.9c-1.4 1-3 1.4-4.6 1.4-5.3-.1-10.9-4.1-14.2-4.5-.6-.1-1.2-.1-1.8-.1-6.1 0-13.1 3.5-19.6 4l-.5-1.9c5.1-2.3 11.2-3.5 17.2-4.6-3.9-3.1-7.3-6.7-9.6-11.4-2 5.2-5.2 10.7-8.5 16.1-3.7 6.1-7 12.6-12 16.2-1.3.9-2.7 1.5-4.2 1.5-1.1-.5-2-.7-2.9-1.1zM66 47.7h.5c-.5-.2-.8-.4-1.1-.6-.5-.3-.9-.6-1.2-.6-1.1-.3-2.6-.4-4.2-.4h-2.9c2.5 1 5.4 1.6 8.9 1.6zM51.1 45H51h.1zm-2.5-.6c-1.7-1.1-3.5-2.3-5.3-3.6 1.1 1 2.3 1.9 3.5 2.8l1.1.8h.7zm-14.8-18v.4c0 .4-.1.8-.1 1.2l.3-1.1v-.4c0-.3-.1-.6-.1-.9l-.1-.3c-.1.3 0 .7 0 1.1z",
    fill: "url(#d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.378c751f0384e1d2f665f23fea80ab35.svg";
export { ForwardRef as ReactComponent };